<template>
  <button class="addNewButton" @click="$emit('click')">
    <span class="mainText">{{ main_text }}</span>
    <span class="subText">{{ sub_text }}</span>
  </button>
</template>
<script>
export default {
  name: 'AddButtonInForm',
  props: {
    main_text: {
      type: String
    },
    sub_text: {
      type: String
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/scss/components/addButtonInForm.scss";
</style>
